const initialState = {
  comingSoon: false,
  count: 0,
  language: "en",
  error: {
    status: false,
    message: "",
    severity: "info",
  },
  currentUser: {
    emailAddress: "",
    password: "",
    token: "",
    username: "",
    userId: "",
    confirmEmailAddress: "",
    confirmPassword: "",
    isSaving: false,
    isAuthenticated: false,
    signUpError: "",
    signInError: "",
    signInEmail: "",
    signInPassword: "",
    signUpEmail: "",
    signUpPassword: "",
    editProfile: false,
    isTermsAccepted: false,
    mobileNumber: "",
    language: "",
    profileStatus: "active",
    plan: "free", // "free" | "silver" | "gold" | "platinum"
    planExpiresAt: null, // ISO date string or null
  },
  isLoading: false,
};

export default initialState;
